export const CLUB_AFFILIATION_YEAR = 2027;

export const FORM_SECTIONS = [
    { id: 'details', label: 'Club Details' },
    { id: 'junior', label: 'Junior Members' },
    { id: 'officers', label: 'Officers' },
    { id: 'bank', label: 'Bank Details' },
    { id: 'membership', label: 'Membership Types' },
    { id: 'documents', label: 'Documents & Settings' },
    { id: 'submit', label: 'Review & Submit' }
];

export const JUNIOR_MEMBERSHIP_TYPES = [
    { label: 'Kids Membership (0-14 yrs)', value: 'Junior Race Licence - Tri Kids 0-14' },
    { label: 'Youths Membership (15-17 yrs)', value: 'Junior Race Licence - Youths 15-17' },
    { label: 'Junior Membership (16-19 yrs)', value: 'Junior Race Licence - Juniors 16-19' }
];

export const IRISH_COUNTIES = [
    'Antrim', 'Armagh', 'Carlow', 'Cavan', 'Clare', 'Cork', 'Derry',
    'Donegal', 'Down', 'Dublin', 'Dublin 1', 'Dublin 2', 'Dublin 3',
    'Dublin 4', 'Dublin 5', 'Dublin 6', 'Dublin 6W', 'Dublin 7',
    'Dublin 8', 'Dublin 9', 'Dublin 10', 'Dublin 11', 'Dublin 12',
    'Dublin 13', 'Dublin 14', 'Dublin 15', 'Dublin 16', 'Dublin 17',
    'Dublin 18', 'Dublin 19', 'Dublin 20', 'Dublin 21', 'Dublin 22',
    'Dublin 23', 'Dublin 24', 'Fermanagh', 'Galway', 'Kerry',
    'Kildare', 'Kilkenny', 'Laois', 'Leitrim', 'Limerick', 'Longford',
    'Louth', 'Mayo', 'Meath', 'Monaghan', 'Offaly', 'Roscommon',
    'Sligo', 'Tipperary', 'Tyrone', 'Waterford', 'Westmeath',
    'Wexford', 'Wicklow', 'Outside Ireland'
];

export const YES_NO_OPTIONS = ['No', 'Yes'];

export const YES_NO_SELECT_OPTIONS = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
];

export const MAX_ADDITIONAL_OFFICERS = 3;

export const FIRST_YEAR = 1900;

export const MIN_CLUB_FOUNDATION_YEAR = 1900;
export const MAX_CLUB_MEMBERS = 1000;
export const MIN_CLUB_MEMBERS = 1;
export const MIN_CLUB_NAME_LENGTH = 3;
export const MAX_MEMBERSHIP_PRICE = 999;
export const MIN_MEMBERSHIP_PRICE = 0;
export const MEMBERSHIP_PRICE_PRECISION = 2;
export const MAX_FILE_UPLOADS = 1;
export const MAX_FILE_SIZE_MB = 10;
export const DEFAULTS = {
    maxLength: {
        short: 50,
        medium: 100,
        standard: 250,
        long: 500,
        extraLong: 1000
    }
};

export const OFFICER_TYPES = [
    { key: 'chairperson', title: 'Chairperson', memberNoLabel: 'TI Licence No.', isMandatory: true },
    { key: 'treasurer', title: 'Treasurer', memberNoLabel: 'TI Licence No.', isMandatory: true },
    { key: 'secretary', title: 'Secretary', memberNoLabel: 'TI Licence No.', isMandatory: true },
    { key: 'membershipOfficer', title: 'Membership Officer', memberNoLabel: 'TI Number No', isMandatory: true, emailMandatory: true },
    { key: 'womensOfficer', title: "Women's Officer", memberNoLabel: 'TI Member No.', isMandatory: true },
    { key: 'inclusionDiversityOfficer', title: 'Inclusion & Diversity Officer', memberNoLabel: 'TI Member No.', isMandatory: true },
    { key: 'safeguardingOfficer', title: 'Safeguarding Officer', memberNoLabel: 'TI Member No.', isMandatory: false, conditionalOn: 'hasJuniorMembers' },
    { key: 'designatedLiaisonPerson', title: 'Designated Liaison Person', memberNoLabel: 'TI Number No', isMandatory: false }
];

export function createEmptyOfficer() {
    return {
        memberNo: '',
        name: '',
        email: ''
    };
}

export function normalizeOfficer(officer) {
    return {
        ...createEmptyOfficer(),
        ...(officer || {})
    };
}

export function createEmptyAdditionalOfficer() {
    return {
        type: '',
        memberNo: '',
        name: '',
        email: '',
        typeValid: true,
        memberNoValid: false,
        nameValid: true,
        emailValid: true
    };
}

export function normalizeAdditionalOfficer(officer) {
    return {
        ...createEmptyAdditionalOfficer(),
        ...(officer || {})
    };
}

export function createInitialClubState() {
    const currentYear = new Date().getFullYear();
    return {
        id: null,
        clubYearDataId: null,
        name: '',
        description: '',
        membersLimit: null,
        year: currentYear,
        clubWebsite: '',
        clubEmail: '',
        town: '',
        county: '',
        noOfMembersLastYear: null,
        yearFormed: currentYear,
        facebook: '',
        twitter: '',
        allowClubRenewalOptIn: null,
        isRenewalOptInOffered: false,
        hasJuniorMembers: false,
        juniorMembersLimit: null,
        juniorAgeGroups: [],
        juniorAgeGroupsAdditional: '',
        chairperson: createEmptyOfficer(),
        treasurer: createEmptyOfficer(),
        secretary: createEmptyOfficer(),
        membershipOfficer: createEmptyOfficer(),
        womensOfficer: createEmptyOfficer(),
        safeguardingOfficer: createEmptyOfficer(),
        inclusionDiversityOfficer: createEmptyOfficer(),
        designatedLiaisonPerson: createEmptyOfficer(),
        additionalOfficers: [],
        bankAccountName: '',
        bankName: '',
        bankAddress: '',
        iban: '',
        bicNumber: '',
        safeguardStatementLink: '',
        safeguardStatementDescription: '',
        termsConditionsFiles: [],
        safeguardingStatementFiles: [],
        notificationState: false,
        notificationEmailAddress: '',
        feePaymentType: 'Online',
        acceptTerms: false
    };
}

export function createInitialValidationState() {
    return {
        clubName: false,
        clubEmail: false,
        clubWebsite: false,
        yearFormed: false,
        town: false,
        county: false,
        noOfMembersLastYear: false,
        membersLimit: false,
        allowClubRenewalOptIn: false,
        facebook: true,
        twitter: true,
        description: false,
        chairpersonMemberNo: false,
        chairpersonName: true,
        chairpersonEmail: true,
        treasurerMemberNo: false,
        treasurerName: true,
        treasurerEmail: true,
        secretaryMemberNo: false,
        secretaryName: true,
        secretaryEmail: true,
        membershipOfficerMemberNo: false,
        membershipOfficerName: true,
        membershipOfficerEmail: false,
        womensOfficerMemberNo: false,
        womensOfficerName: true,
        womensOfficerEmail: true,
        safeguardingOfficerMemberNo: false,
        safeguardingOfficerName: true,
        safeguardingOfficerEmail: true,
        inclusionDiversityOfficerMemberNo: false,
        inclusionDiversityOfficerName: true,
        inclusionDiversityOfficerEmail: true,
        designatedLiaisonPersonMemberNo: true,
        designatedLiaisonPersonName: true,
        designatedLiaisonPersonEmail: true,
        juniorMembersLimit: false,
        juniorAgeGroupsAdditional: true,
        bankAccountName: false,
        bankName: false,
        bankAddress: false,
        iban: false,
        bicNumber: false,
        safeguardStatementLink: true,
        safeguardStatementDescription: true,
        termsConditionsFiles: true,
        safeguardingStatementFiles: true,
        notificationEmailAddress: true,
        acceptTerms: false
    };
}

export function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= FIRST_YEAR; year--) {
        const yearStr = year.toString();
        years.push({ label: yearStr, value: yearStr });
    }
    return years;
}

export function formatCountyOptions(counties) {
    return counties.map(county => ({ label: county, value: county }));
}

export function parseIntOrNull(value) {
    return value != null ? parseInt(value, 10) : null;
}

export function toStringOrEmpty(value) {
    return value != null ? value.toString() : '';
}

export function buildMembershipTypeRemovalWarning(removedMembershipTypes) {
    const types = removedMembershipTypes || [];

    return {
        intro: types.length === 1
            ? 'You are removing a membership type that members have opted in to renew:'
            : 'You are removing membership types that members have opted in to renew:',
        items: types.map(type => {
            const count = type.affectedMemberCount || 0;
            return {
                label: (type.name || '').trim() || 'Unnamed membership type',
                meta: `${count} ${count === 1 ? 'member' : 'members'}`
            };
        }),
        note: 'Their club membership will not renew automatically.'
    };
}

export function buildMembershipTypeStatusChangeWarning(result) {
    const clubs = (result && result.affectedClubs) || [];
    const total = (result && result.totalAffectedMembers) || 0;
    const typeName = ((result && result.membershipTypeName) || '').trim() || 'This membership type';

    return {
        intro: `${typeName} is set to renew automatically for ${total} ${total === 1 ? 'member' : 'members'} `
            + `in ${clubs.length} ${clubs.length === 1 ? 'club' : 'clubs'}:`,
        items: clubs.map(club => {
            const count = club.affectedMemberCount || 0;
            return {
                label: (club.clubName || '').trim() || 'Unnamed club',
                meta: `${count} ${count === 1 ? 'member' : 'members'}`
            };
        }),
        note: 'Their club membership will not renew automatically.'
    };
}

const CLUB_DETAILS_VALIDATION_FIELDS = [
    'clubName',
    'clubEmail',
    'clubWebsite',
    'yearFormed',
    'town',
    'county',
    'noOfMembersLastYear',
    'membersLimit',
    'allowClubRenewalOptIn',
    'facebook',
    'twitter'
];

const REQUIRED_OFFICER_KEYS = [
    'chairperson',
    'treasurer',
    'secretary',
    'membershipOfficer',
    'womensOfficer',
    'inclusionDiversityOfficer'
];

const OPTIONAL_OFFICER_KEYS = [
    'designatedLiaisonPerson'
];

const BANK_DETAILS_VALIDATION_FIELDS = [
    'bankAccountName',
    'bankName',
    'bankAddress',
    'iban',
    'bicNumber'
];

const DOCUMENTS_SETTINGS_VALIDATION_FIELDS = [
    'safeguardStatementLink',
    'safeguardStatementDescription',
    'termsConditionsFiles',
    'safeguardingStatementFiles',
    'notificationEmailAddress'
];

function areValidationFieldsValid(validation, fields) {
    return fields.every(field => validation[field] === true);
}

function getOfficerValidationFields(officerKey) {
    return [
        officerKey + 'MemberNo',
        officerKey + 'Name',
        officerKey + 'Email'
    ];
}

function hasJuniorMembers(club) {
    return club.hasJuniorMembers === true || club.hasJuniorMembers === 'Yes';
}

function areAdditionalOfficersValid(additionalOfficers) {
    if (!additionalOfficers || !additionalOfficers.length) return true;

    return additionalOfficers.every(officer =>
        officer.memberNoValid === true &&
        officer.typeValid !== false &&
        officer.nameValid !== false &&
        officer.emailValid !== false
    );
}

function isClubDetailsValid(validation, requireRenewalOptIn) {
    const fields = requireRenewalOptIn
        ? CLUB_DETAILS_VALIDATION_FIELDS
        : CLUB_DETAILS_VALIDATION_FIELDS.filter(field => field !== 'allowClubRenewalOptIn');

    return areValidationFieldsValid(validation, fields);
}

function isJuniorMembersSectionValid(club, validation) {
    return validation.juniorAgeGroupsAdditional !== false &&
        (!hasJuniorMembers(club) || validation.juniorMembersLimit === true);
}

function isOfficersSectionValid(club, validation) {
    const requiredOfficersValid = REQUIRED_OFFICER_KEYS.every(officerKey =>
        areValidationFieldsValid(validation, getOfficerValidationFields(officerKey))
    );

    const optionalOfficersValid = OPTIONAL_OFFICER_KEYS.every(officerKey =>
        areValidationFieldsValid(validation, getOfficerValidationFields(officerKey))
    );

    const safeguardingOfficerValid = !hasJuniorMembers(club) || areValidationFieldsValid(
        validation,
        getOfficerValidationFields('safeguardingOfficer')
    );

    return requiredOfficersValid &&
        optionalOfficersValid &&
        safeguardingOfficerValid &&
        areAdditionalOfficersValid(club.additionalOfficers);
}

function isBankDetailsValid(validation) {
    return areValidationFieldsValid(validation, BANK_DETAILS_VALIDATION_FIELDS);
}

function isMembershipTypesSectionValid(club, assignedMembershipTypes) {
    return !!assignedMembershipTypes && assignedMembershipTypes.length > 0;
}

function isDocumentsSettingsSectionValid(validation) {
    return areValidationFieldsValid(validation, DOCUMENTS_SETTINGS_VALIDATION_FIELDS);
}

export function getClubRegistrationValidationErrors(club, assignedMembershipTypes, validation = {}, options = {}) {
    const requireTerms = options.requireTerms === true;
    const requireRenewalOptIn = options.requireRenewalOptIn === true;

    return {
        details: !isClubDetailsValid(validation, requireRenewalOptIn),
        junior: !isJuniorMembersSectionValid(club, validation),
        officers: !isOfficersSectionValid(club, validation),
        bank: !isBankDetailsValid(validation),
        membership: !isMembershipTypesSectionValid(club, assignedMembershipTypes),
        documents: !isDocumentsSettingsSectionValid(validation),
        submit: requireTerms && validation.acceptTerms !== true
    };
}

export function hasClubRegistrationValidationErrors(sectionId, club, assignedMembershipTypes, validation = {}, options = {}) {
    const errors = getClubRegistrationValidationErrors(club, assignedMembershipTypes, validation, options);
    return Boolean(errors[sectionId]);
}

export function isClubRegistrationFormValid(club, assignedMembershipTypes, validation = {}, options = {}) {
    const errors = getClubRegistrationValidationErrors(club, assignedMembershipTypes, validation, options);
    return Object.keys(errors).every(key => !errors[key]);
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/constants/club-registration-constants.js